/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WiedzaRouteImport } from './routes/wiedza'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WiedzaZywiolRouteImport } from './routes/wiedza.zywiol'
import { Route as WiedzaZodiakRouteImport } from './routes/wiedza.zodiak'
import { Route as WiedzaPlanetyRouteImport } from './routes/wiedza.planety'
import { Route as WiedzaNumerologiaRouteImport } from './routes/wiedza.numerologia'
import { Route as WiedzaDomyRouteImport } from './routes/wiedza.domy'
import { Route as WiedzaChinskiRouteImport } from './routes/wiedza.chinski'
import { Route as WiedzaAspektyRouteImport } from './routes/wiedza.aspekty'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthedTodayRouteImport } from './routes/_authed.today'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedOnboardingRouteImport } from './routes/_authed.onboarding'
import { Route as AuthedDirectoryRouteImport } from './routes/_authed.directory'
import { Route as AuthedCalcRouteImport } from './routes/_authed.calc'
import { Route as AuthedSettingsDeleteAccountRouteImport } from './routes/_authed.settings.delete-account'
import { Route as AuthedProfileEditRouteImport } from './routes/_authed.profile.edit'
import { Route as AuthedDirectoryNewRouteImport } from './routes/_authed.directory.new'
import { Route as AuthedDirectoryIdRouteImport } from './routes/_authed.directory.$id'
import { Route as AuthedDirectoryIdEditRouteImport } from './routes/_authed.directory.$id.edit'
import { Route as AuthedDirectoryCompareABRouteImport } from './routes/_authed.directory.compare.$a.$b'

const WiedzaRoute = WiedzaRouteImport.update({
  id: '/wiedza',
  path: '/wiedza',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WiedzaZywiolRoute = WiedzaZywiolRouteImport.update({
  id: '/zywiol',
  path: '/zywiol',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaZodiakRoute = WiedzaZodiakRouteImport.update({
  id: '/zodiak',
  path: '/zodiak',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaPlanetyRoute = WiedzaPlanetyRouteImport.update({
  id: '/planety',
  path: '/planety',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaNumerologiaRoute = WiedzaNumerologiaRouteImport.update({
  id: '/numerologia',
  path: '/numerologia',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaDomyRoute = WiedzaDomyRouteImport.update({
  id: '/domy',
  path: '/domy',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaChinskiRoute = WiedzaChinskiRouteImport.update({
  id: '/chinski',
  path: '/chinski',
  getParentRoute: () => WiedzaRoute,
} as any)
const WiedzaAspektyRoute = WiedzaAspektyRouteImport.update({
  id: '/aspekty',
  path: '/aspekty',
  getParentRoute: () => WiedzaRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTodayRoute = AuthedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDirectoryRoute = AuthedDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCalcRoute = AuthedCalcRouteImport.update({
  id: '/calc',
  path: '/calc',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsDeleteAccountRoute =
  AuthedSettingsDeleteAccountRouteImport.update({
    id: '/delete-account',
    path: '/delete-account',
    getParentRoute: () => AuthedSettingsRoute,
  } as any)
const AuthedProfileEditRoute = AuthedProfileEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthedProfileRoute,
} as any)
const AuthedDirectoryNewRoute = AuthedDirectoryNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedDirectoryRoute,
} as any)
const AuthedDirectoryIdRoute = AuthedDirectoryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedDirectoryRoute,
} as any)
const AuthedDirectoryIdEditRoute = AuthedDirectoryIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthedDirectoryIdRoute,
} as any)
const AuthedDirectoryCompareABRoute =
  AuthedDirectoryCompareABRouteImport.update({
    id: '/compare/$a/$b',
    path: '/compare/$a/$b',
    getParentRoute: () => AuthedDirectoryRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/wiedza': typeof WiedzaRouteWithChildren
  '/calc': typeof AuthedCalcRoute
  '/directory': typeof AuthedDirectoryRouteWithChildren
  '/onboarding': typeof AuthedOnboardingRoute
  '/profile': typeof AuthedProfileRouteWithChildren
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/today': typeof AuthedTodayRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/wiedza/aspekty': typeof WiedzaAspektyRoute
  '/wiedza/chinski': typeof WiedzaChinskiRoute
  '/wiedza/domy': typeof WiedzaDomyRoute
  '/wiedza/numerologia': typeof WiedzaNumerologiaRoute
  '/wiedza/planety': typeof WiedzaPlanetyRoute
  '/wiedza/zodiak': typeof WiedzaZodiakRoute
  '/wiedza/zywiol': typeof WiedzaZywiolRoute
  '/directory/$id': typeof AuthedDirectoryIdRouteWithChildren
  '/directory/new': typeof AuthedDirectoryNewRoute
  '/profile/edit': typeof AuthedProfileEditRoute
  '/settings/delete-account': typeof AuthedSettingsDeleteAccountRoute
  '/directory/$id/edit': typeof AuthedDirectoryIdEditRoute
  '/directory/compare/$a/$b': typeof AuthedDirectoryCompareABRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/wiedza': typeof WiedzaRouteWithChildren
  '/calc': typeof AuthedCalcRoute
  '/directory': typeof AuthedDirectoryRouteWithChildren
  '/onboarding': typeof AuthedOnboardingRoute
  '/profile': typeof AuthedProfileRouteWithChildren
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/today': typeof AuthedTodayRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/wiedza/aspekty': typeof WiedzaAspektyRoute
  '/wiedza/chinski': typeof WiedzaChinskiRoute
  '/wiedza/domy': typeof WiedzaDomyRoute
  '/wiedza/numerologia': typeof WiedzaNumerologiaRoute
  '/wiedza/planety': typeof WiedzaPlanetyRoute
  '/wiedza/zodiak': typeof WiedzaZodiakRoute
  '/wiedza/zywiol': typeof WiedzaZywiolRoute
  '/directory/$id': typeof AuthedDirectoryIdRouteWithChildren
  '/directory/new': typeof AuthedDirectoryNewRoute
  '/profile/edit': typeof AuthedProfileEditRoute
  '/settings/delete-account': typeof AuthedSettingsDeleteAccountRoute
  '/directory/$id/edit': typeof AuthedDirectoryIdEditRoute
  '/directory/compare/$a/$b': typeof AuthedDirectoryCompareABRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/wiedza': typeof WiedzaRouteWithChildren
  '/_authed/calc': typeof AuthedCalcRoute
  '/_authed/directory': typeof AuthedDirectoryRouteWithChildren
  '/_authed/onboarding': typeof AuthedOnboardingRoute
  '/_authed/profile': typeof AuthedProfileRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRouteWithChildren
  '/_authed/today': typeof AuthedTodayRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/wiedza/aspekty': typeof WiedzaAspektyRoute
  '/wiedza/chinski': typeof WiedzaChinskiRoute
  '/wiedza/domy': typeof WiedzaDomyRoute
  '/wiedza/numerologia': typeof WiedzaNumerologiaRoute
  '/wiedza/planety': typeof WiedzaPlanetyRoute
  '/wiedza/zodiak': typeof WiedzaZodiakRoute
  '/wiedza/zywiol': typeof WiedzaZywiolRoute
  '/_authed/directory/$id': typeof AuthedDirectoryIdRouteWithChildren
  '/_authed/directory/new': typeof AuthedDirectoryNewRoute
  '/_authed/profile/edit': typeof AuthedProfileEditRoute
  '/_authed/settings/delete-account': typeof AuthedSettingsDeleteAccountRoute
  '/_authed/directory/$id/edit': typeof AuthedDirectoryIdEditRoute
  '/_authed/directory/compare/$a/$b': typeof AuthedDirectoryCompareABRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/wiedza'
    | '/calc'
    | '/directory'
    | '/onboarding'
    | '/profile'
    | '/settings'
    | '/today'
    | '/auth/callback'
    | '/wiedza/aspekty'
    | '/wiedza/chinski'
    | '/wiedza/domy'
    | '/wiedza/numerologia'
    | '/wiedza/planety'
    | '/wiedza/zodiak'
    | '/wiedza/zywiol'
    | '/directory/$id'
    | '/directory/new'
    | '/profile/edit'
    | '/settings/delete-account'
    | '/directory/$id/edit'
    | '/directory/compare/$a/$b'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/wiedza'
    | '/calc'
    | '/directory'
    | '/onboarding'
    | '/profile'
    | '/settings'
    | '/today'
    | '/auth/callback'
    | '/wiedza/aspekty'
    | '/wiedza/chinski'
    | '/wiedza/domy'
    | '/wiedza/numerologia'
    | '/wiedza/planety'
    | '/wiedza/zodiak'
    | '/wiedza/zywiol'
    | '/directory/$id'
    | '/directory/new'
    | '/profile/edit'
    | '/settings/delete-account'
    | '/directory/$id/edit'
    | '/directory/compare/$a/$b'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/signup'
    | '/wiedza'
    | '/_authed/calc'
    | '/_authed/directory'
    | '/_authed/onboarding'
    | '/_authed/profile'
    | '/_authed/settings'
    | '/_authed/today'
    | '/auth/callback'
    | '/wiedza/aspekty'
    | '/wiedza/chinski'
    | '/wiedza/domy'
    | '/wiedza/numerologia'
    | '/wiedza/planety'
    | '/wiedza/zodiak'
    | '/wiedza/zywiol'
    | '/_authed/directory/$id'
    | '/_authed/directory/new'
    | '/_authed/profile/edit'
    | '/_authed/settings/delete-account'
    | '/_authed/directory/$id/edit'
    | '/_authed/directory/compare/$a/$b'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  WiedzaRoute: typeof WiedzaRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wiedza': {
      id: '/wiedza'
      path: '/wiedza'
      fullPath: '/wiedza'
      preLoaderRoute: typeof WiedzaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiedza/zywiol': {
      id: '/wiedza/zywiol'
      path: '/zywiol'
      fullPath: '/wiedza/zywiol'
      preLoaderRoute: typeof WiedzaZywiolRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/zodiak': {
      id: '/wiedza/zodiak'
      path: '/zodiak'
      fullPath: '/wiedza/zodiak'
      preLoaderRoute: typeof WiedzaZodiakRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/planety': {
      id: '/wiedza/planety'
      path: '/planety'
      fullPath: '/wiedza/planety'
      preLoaderRoute: typeof WiedzaPlanetyRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/numerologia': {
      id: '/wiedza/numerologia'
      path: '/numerologia'
      fullPath: '/wiedza/numerologia'
      preLoaderRoute: typeof WiedzaNumerologiaRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/domy': {
      id: '/wiedza/domy'
      path: '/domy'
      fullPath: '/wiedza/domy'
      preLoaderRoute: typeof WiedzaDomyRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/chinski': {
      id: '/wiedza/chinski'
      path: '/chinski'
      fullPath: '/wiedza/chinski'
      preLoaderRoute: typeof WiedzaChinskiRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/wiedza/aspekty': {
      id: '/wiedza/aspekty'
      path: '/aspekty'
      fullPath: '/wiedza/aspekty'
      preLoaderRoute: typeof WiedzaAspektyRouteImport
      parentRoute: typeof WiedzaRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/today': {
      id: '/_authed/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthedTodayRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/onboarding': {
      id: '/_authed/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthedOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/directory': {
      id: '/_authed/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof AuthedDirectoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/calc': {
      id: '/_authed/calc'
      path: '/calc'
      fullPath: '/calc'
      preLoaderRoute: typeof AuthedCalcRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/delete-account': {
      id: '/_authed/settings/delete-account'
      path: '/delete-account'
      fullPath: '/settings/delete-account'
      preLoaderRoute: typeof AuthedSettingsDeleteAccountRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/profile/edit': {
      id: '/_authed/profile/edit'
      path: '/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof AuthedProfileEditRouteImport
      parentRoute: typeof AuthedProfileRoute
    }
    '/_authed/directory/new': {
      id: '/_authed/directory/new'
      path: '/new'
      fullPath: '/directory/new'
      preLoaderRoute: typeof AuthedDirectoryNewRouteImport
      parentRoute: typeof AuthedDirectoryRoute
    }
    '/_authed/directory/$id': {
      id: '/_authed/directory/$id'
      path: '/$id'
      fullPath: '/directory/$id'
      preLoaderRoute: typeof AuthedDirectoryIdRouteImport
      parentRoute: typeof AuthedDirectoryRoute
    }
    '/_authed/directory/$id/edit': {
      id: '/_authed/directory/$id/edit'
      path: '/edit'
      fullPath: '/directory/$id/edit'
      preLoaderRoute: typeof AuthedDirectoryIdEditRouteImport
      parentRoute: typeof AuthedDirectoryIdRoute
    }
    '/_authed/directory/compare/$a/$b': {
      id: '/_authed/directory/compare/$a/$b'
      path: '/compare/$a/$b'
      fullPath: '/directory/compare/$a/$b'
      preLoaderRoute: typeof AuthedDirectoryCompareABRouteImport
      parentRoute: typeof AuthedDirectoryRoute
    }
  }
}

interface AuthedDirectoryIdRouteChildren {
  AuthedDirectoryIdEditRoute: typeof AuthedDirectoryIdEditRoute
}

const AuthedDirectoryIdRouteChildren: AuthedDirectoryIdRouteChildren = {
  AuthedDirectoryIdEditRoute: AuthedDirectoryIdEditRoute,
}

const AuthedDirectoryIdRouteWithChildren =
  AuthedDirectoryIdRoute._addFileChildren(AuthedDirectoryIdRouteChildren)

interface AuthedDirectoryRouteChildren {
  AuthedDirectoryIdRoute: typeof AuthedDirectoryIdRouteWithChildren
  AuthedDirectoryNewRoute: typeof AuthedDirectoryNewRoute
  AuthedDirectoryCompareABRoute: typeof AuthedDirectoryCompareABRoute
}

const AuthedDirectoryRouteChildren: AuthedDirectoryRouteChildren = {
  AuthedDirectoryIdRoute: AuthedDirectoryIdRouteWithChildren,
  AuthedDirectoryNewRoute: AuthedDirectoryNewRoute,
  AuthedDirectoryCompareABRoute: AuthedDirectoryCompareABRoute,
}

const AuthedDirectoryRouteWithChildren = AuthedDirectoryRoute._addFileChildren(
  AuthedDirectoryRouteChildren,
)

interface AuthedProfileRouteChildren {
  AuthedProfileEditRoute: typeof AuthedProfileEditRoute
}

const AuthedProfileRouteChildren: AuthedProfileRouteChildren = {
  AuthedProfileEditRoute: AuthedProfileEditRoute,
}

const AuthedProfileRouteWithChildren = AuthedProfileRoute._addFileChildren(
  AuthedProfileRouteChildren,
)

interface AuthedSettingsRouteChildren {
  AuthedSettingsDeleteAccountRoute: typeof AuthedSettingsDeleteAccountRoute
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsDeleteAccountRoute: AuthedSettingsDeleteAccountRoute,
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedCalcRoute: typeof AuthedCalcRoute
  AuthedDirectoryRoute: typeof AuthedDirectoryRouteWithChildren
  AuthedOnboardingRoute: typeof AuthedOnboardingRoute
  AuthedProfileRoute: typeof AuthedProfileRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren
  AuthedTodayRoute: typeof AuthedTodayRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCalcRoute: AuthedCalcRoute,
  AuthedDirectoryRoute: AuthedDirectoryRouteWithChildren,
  AuthedOnboardingRoute: AuthedOnboardingRoute,
  AuthedProfileRoute: AuthedProfileRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedTodayRoute: AuthedTodayRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface WiedzaRouteChildren {
  WiedzaAspektyRoute: typeof WiedzaAspektyRoute
  WiedzaChinskiRoute: typeof WiedzaChinskiRoute
  WiedzaDomyRoute: typeof WiedzaDomyRoute
  WiedzaNumerologiaRoute: typeof WiedzaNumerologiaRoute
  WiedzaPlanetyRoute: typeof WiedzaPlanetyRoute
  WiedzaZodiakRoute: typeof WiedzaZodiakRoute
  WiedzaZywiolRoute: typeof WiedzaZywiolRoute
}

const WiedzaRouteChildren: WiedzaRouteChildren = {
  WiedzaAspektyRoute: WiedzaAspektyRoute,
  WiedzaChinskiRoute: WiedzaChinskiRoute,
  WiedzaDomyRoute: WiedzaDomyRoute,
  WiedzaNumerologiaRoute: WiedzaNumerologiaRoute,
  WiedzaPlanetyRoute: WiedzaPlanetyRoute,
  WiedzaZodiakRoute: WiedzaZodiakRoute,
  WiedzaZywiolRoute: WiedzaZywiolRoute,
}

const WiedzaRouteWithChildren =
  WiedzaRoute._addFileChildren(WiedzaRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  WiedzaRoute: WiedzaRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
